import React, { useEffect, useState } from "react";
import { CircularProgress, makeStyles, Table, TableBody, TableContainer, TableHead, TableRow} from "@material-ui/core";
import axios from "axios";
import {MemberInfo, RoleInfo} from "../types/UserInfoTypes";
import config from '../config'

const useStyles = makeStyles({
  stickyHeader: {
    position: "sticky",
    left: 0,
    top:0,
    backgroundColor: "white",
  }
});

export function Roles( props: {
  member: MemberInfo,
}): JSX.Element {
  const [loading, setLoading] = useState(false)
  const [userRoles, setUserRoles] = useState<RoleInfo[]>([]);
  
  const classes = useStyles();

  useEffect(() => {
    fetchRoles(props.member);
  }, []);

  async function fetchRoles(member: MemberInfo) {
    try {
      setLoading(true);
      const userId = member.id;
      await axios.post(`${config.flowableUiApiBaseUrl}idm-app/rest/user/keycloak-roles`, {userId}, { withCredentials: true }).then((response) => {
          const roles = response.data;
          if(roles.length > 0){
            setUserRoles(roles);
          } else {
            setUserRoles([]);
          }
          
      })

    } catch (e) {
      console.error(e);
    }
    finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <CircularProgress id={"changeRequestorLoader"}/>;
  }

  if (userRoles.length === 0) {
      return <div style={{marginTop: 5, marginBottom: 20}}>This user has no roles.</div>
  }

  return (
    <TableContainer style={{marginTop: 0, marginBottom: 30}}>
        <Table stickyHeader
        aria-label="simple table"
        style={{ tableLayout: "fixed" }}>
            <TableHead>
                <TableRow>
                    <th align="left" style={{ width: '220px', maxWidth: '220px', paddingLeft: '5px' }} className={classes.stickyHeader}>Name</th>
                    <th align="left" style={{ width: '320px', maxWidth: '320px', paddingLeft: '10px'}} className={classes.stickyHeader}>Description</th>
                </TableRow>
            </TableHead>
            <TableBody>
                {userRoles.map((role) => (
                    <TableRow key={role.id}>
                        <td style={{ paddingLeft: '10px' }}>{role.name}</td>
                        <td style={{ paddingLeft: '10px'}}>{role.description ? (role.description).replace(/[{}$]/g, '') : ''}</td>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
  );
}
